const ROLE_MAP = {
    1: 'User',
    2: 'Admin',
    User: 'User',
    Admin: 'Admin',
}

const getUserRoleAuthStatus = (pathname, user, routes) => {
    const matched = routes.find((r) => r.path === pathname)
    console.log(user.userRole)

    const roleName = ROLE_MAP[user.userRole] || user.userRole

    console.log('rolename', roleName)

    if (matched && matched.auth && matched.auth.length) {
        const allowedRoles = matched.auth
        return allowedRoles.includes(roleName)
    }
    return true
}

export default getUserRoleAuthStatus
